export const RECEIVE_ENTITIES = 'entities/RECEIVE_ENTITIES';
export const ADD_ENTITY = 'entities/ADD_ENTITY';
export const EDIT_ENTITY = 'entities/EDIT_ENTITY';
export const REMOVE_ENTITY = 'entities/REMOVE_ENTITY';
